module.exports = __webpack_public_path__ + "static/img/3a.bb42c32.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/why/3a.png
// module id = Lxwg
// module chunks = 1